import { sendPost } from '../http.js'
const api = {
	'createExportAPI': { // 创建导出任务接口
        url: '/user/export/create'
    },
    'getExportListAPI': { // 任务列表
        url: '/user/export/list'
    },
    'deleteExport': { //删除任务
        url: '/user/export/delete'
    }
}
const requestFunObj = {}
for (const key in api) {
    requestFunObj[key]  = {
        ...api[key],
        requestFun:(params, method='post', headers) => {
            return sendPost(api[key].url, params, method, headers)
        }
    } 
}
export default requestFunObj
